/* eslint-disable no-console */
import firebase from 'firebase/app';
import 'firebase/messaging'; // for cloud messaging
import axios from '@/api';

const firebaseConfig = JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG);
export const initFirebase = () => {
  firebase.initializeApp(firebaseConfig);
};

export const askNotificationsPermissions = async () => {
  try {
    const messaging = firebase.messaging();
    await Notification.requestPermission();
    const token = await messaging.getToken();
    axios.post('/novo_dispositivo', { token_fcm: token });
    return token;
  } catch (error) {
    return error;
  }
};
